import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import useLogger from '../../../../../hooks/useLogger';

import {
  Container,
  Title,
  NoSubscriptionAllowIcon,
} from './styles';
import texts from './texts.json';

const SubscriptionUnavailable = ({
  planData,
  isChallenge,
}) => {
  const { logEvent } = useLogger();

  useEffect(() => {
    logEvent('subscriptionUnavailableShown', planData);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <NoSubscriptionAllowIcon />
      <Title>{isChallenge ? texts.challengeEnded : texts.noNewAvailable}</Title>
    </Container>
  );
};

SubscriptionUnavailable.propTypes = {
  planData: PropTypes.object.isRequired,
  isChallenge: PropTypes.bool,
};

SubscriptionUnavailable.defaultProps = {
  isChallenge: false,
};

export default SubscriptionUnavailable;
